export default __webpack_public_path__ + "static/media/BLACKDECKER_HB_1.24bd9ea0.png";